// import { ResponsiveBlock } from '~/mui/ResponsiveBlock'
import { ConnectedData } from './components'

export const SPSocketLab = () => {
  return (
    <ConnectedData />
  ) 
}
